import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../controls/Modal';

// Диалог отклонения сдачи: комментарий обязателен — уходит команде в уведомление.
export default function RejectModal({ title, onReject, onClose }) {
    const [comment, setComment] = useState('');
    const valid = comment.trim().length > 0;

    return (
        <Modal
            open
            size="sm"
            kicker="Отклонение сдачи"
            title={title}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-danger" onClick={() => onReject(comment.trim())} disabled={!valid}>Отклонить</button>
                </>
            )}
        >
            <div>
                <label className="ctl-label">Комментарий для команды *</label>
                <textarea
                    className="textarea"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Почему сдача не принята — команда увидит это и сможет пересдать"
                />
            </div>
        </Modal>
    );
}

RejectModal.propTypes = {
    title: PropTypes.string.isRequired,
    onReject: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
